var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpreuveCoffre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 150,
    viewBox: "0 0 183 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_70",
    "data-name": "Groupe 70",
    transform: "translate(-911 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_40",
    "data-name": "Groupe 40",
    transform: "translate(930.317 59.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 23,
    height: 5,
    transform: "translate(18.683 57.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 8,
    height: 3,
    transform: "translate(41.683 54.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 7,
    height: 3,
    transform: "translate(11.683 54.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 4,
    height: 4,
    transform: "translate(49.683 50.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 15,
    height: 4,
    transform: "translate(18.683 50.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M94.281,50.664v-3.82h-3.82v-3.82h-3.82V16.281h3.82v-3.82h3.82V8.641H117.2V4.82H105.742V1H94.281V4.82H86.641v3.82H82.82v7.641H79V39.2h3.82v7.641h3.82v3.82Z",
    transform: "translate(-75.28 2.993)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 4,
    height: 4,
    transform: "translate(7.683 50.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 3,
    height: 4,
    transform: "translate(15.683 46.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 3,
    height: 8,
    transform: "translate(53.683 42.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 8,
    height: 4,
    transform: "translate(22.683 42.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 4,
    height: 4,
    transform: "translate(11.683 42.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 4,
    height: 8,
    transform: "translate(3.683 42.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 4,
    height: 4,
    transform: "translate(18.683 38.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 4,
    height: 23,
    transform: "translate(-0.317 19.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 4,
    height: 4,
    transform: "translate(37.683 23.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M94.461,8.82V5H86.82V8.82H83V24.1h3.82v3.82H102.1V24.1h3.82V12.641H102.1V8.82Z",
    transform: "translate(-63.999 14.274)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 4,
    height: 23,
    transform: "translate(56.683 19.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 4,
    height: 4,
    transform: "translate(45.683 19.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 7,
    height: 4,
    transform: "translate(30.683 19.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 3,
    height: 7,
    transform: "translate(53.683 12.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M117.383,6.82h-3.82V3h-7.641V6.82h3.82v3.82h3.82V33.562h-3.82v3.82h-3.82V41.2H98.281v3.82H83v3.82h22.922v-3.82h7.641V41.2h3.82V33.562h3.82V10.641h-3.82Z",
    transform: "translate(-63.999 8.633)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 4,
    height: 3,
    transform: "translate(41.683 16.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M100.1,6.82V3H88.641V6.82H84.82v3.82H81V33.562h3.82v3.82h3.82V41.2h22.922v-3.82h3.82v-3.82h3.82v-19.1h-3.82v-3.82h-3.82V6.82Zm11.461,7.641V29.742h-3.82v3.82H100.1v3.82H92.461v-3.82h-3.82v-19.1h3.82v-3.82h15.281v3.82Z",
    transform: "translate(-69.64 8.633)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 4,
    height: 7,
    transform: "translate(3.683 12.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 4,
    height: 4,
    transform: "translate(49.683 12.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 11,
    height: 4,
    transform: "translate(30.683 12.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 4,
    height: 4,
    transform: "translate(49.683 8.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 8,
    height: 4,
    transform: "translate(41.683 8.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 4,
    height: 4,
    transform: "translate(7.683 8.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 8,
    height: 4,
    transform: "translate(41.683 4.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 11,
    height: 4,
    transform: "translate(30.683 4.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 7,
    height: 4,
    transform: "translate(11.683 4.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 23,
    height: 4,
    transform: "translate(18.683 0.044)",
    fill: "#231e2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_41",
    "data-name": "Groupe 41",
    transform: "translate(-255 -273.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M91.951,27V112.82H6.13V27H0V118.95H98.081V27Z",
    transform: "translate(1166 360.129)",
    fill: "#361a2a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 85.947,
    height: 6.067,
    transform: "translate(1172.067 466.947)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 12.134,
    height: 30.84,
    transform: "translate(1172.067 436.107)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 12.134,
    height: 6.067,
    transform: "translate(1208.974 448.241)",
    fill: "#522b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M39.78,36V48.26H27.52V36H3V60.52H64.3V36Z",
    transform: "translate(1181.389 406.301)",
    fill: "#784028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 12.134,
    height: 6.067,
    transform: "translate(1208.974 442.174)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 12.134,
    height: 30.84,
    transform: "translate(1245.88 436.107)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 61.68,
    height: 6.067,
    transform: "translate(1184.201 436.107)",
    fill: "#522b29"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 85.947,
    height: 6.067,
    transform: "translate(1172.067 430.04)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 12.134,
    height: 18.201,
    transform: "translate(1172.067 411.84)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 12.134,
    height: 18.201,
    transform: "translate(1245.88 411.84)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M21.39,36.13V30H3V54.52H64.3V30H45.91v6.13Z",
    transform: "translate(1181.389 375.52)",
    fill: "#361a2a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 12.134,
    height: 6.067,
    transform: "translate(1245.88 405.773)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 12.134,
    height: 6.067,
    transform: "translate(1172.067 405.773)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 30.84,
    height: 6.572,
    transform: "translate(1227.174 399.201)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M24.39,35.13H12.13V29H6V41.26H30.52V29H24.39Z",
    transform: "translate(1196.779 370.39)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 12.134,
    height: 6.572,
    transform: "translate(1208.974 399.201)",
    fill: "#522b29"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 30.84,
    height: 6.572,
    transform: "translate(1172.067 399.201)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 12.134,
    height: 6.067,
    transform: "translate(1245.88 393.134)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 18.706,
    height: 6.067,
    transform: "translate(1227.174 393.134)",
    fill: "#784028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 24.267,
    height: 6.067,
    transform: "translate(1202.907 393.134)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 18.706,
    height: 6.067,
    transform: "translate(1184.201 393.134)",
    fill: "#784028"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 12.134,
    height: 6.067,
    transform: "translate(1172.067 393.134)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 12.134,
    height: 6.067,
    transform: "translate(1245.88 387.067)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 61.68,
    height: 6.067,
    transform: "translate(1184.201 387.067)",
    fill: "#a6644b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 12.134,
    height: 6.067,
    transform: "translate(1172.067 387.067)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 85.947,
    height: 6.067,
    transform: "translate(1172.067 381)",
    fill: "#361a2a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_38",
    "data-name": "Groupe 38",
    transform: "translate(1004.317 100.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-2",
    "data-name": "Rectangle 57",
    width: 33,
    height: 6,
    transform: "translate(27.683 84.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-2",
    "data-name": "Rectangle 58",
    width: 12,
    height: 5,
    transform: "translate(60.683 79.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-2",
    "data-name": "Rectangle 59",
    width: 11,
    height: 5,
    transform: "translate(16.683 79.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60-2",
    "data-name": "Rectangle 60",
    width: 6,
    height: 6,
    transform: "translate(72.683 73.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61-2",
    "data-name": "Rectangle 61",
    width: 22,
    height: 6,
    transform: "translate(27.683 73.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8-2",
    "data-name": "Trac\\xE9 8",
    d: "M101.363,73.679V68.088H95.772V62.5H90.181V23.363h5.591V17.772h5.591V12.181h33.544V6.591H118.135V1H101.363V6.591H90.181v5.591H84.591V23.363H79V56.907h5.591V68.088h5.591v5.591Z",
    transform: "translate(-73.41 4.823)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62-2",
    "data-name": "Rectangle 62",
    width: 6,
    height: 6,
    transform: "translate(10.683 73.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63-2",
    "data-name": "Rectangle 63",
    width: 5,
    height: 6,
    transform: "translate(22.683 67.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64-2",
    "data-name": "Rectangle 64",
    width: 5,
    height: 11,
    transform: "translate(78.683 62.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65-2",
    "data-name": "Rectangle 65",
    width: 11,
    height: 5,
    transform: "translate(33.683 62.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66-2",
    "data-name": "Rectangle 66",
    width: 6,
    height: 5,
    transform: "translate(16.683 62.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67-2",
    "data-name": "Rectangle 67",
    width: 5,
    height: 11,
    transform: "translate(5.683 62.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68-2",
    "data-name": "Rectangle 68",
    width: 6,
    height: 6,
    transform: "translate(27.683 56.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69-2",
    "data-name": "Rectangle 69",
    width: 6,
    height: 34,
    transform: "translate(-0.317 28.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70-2",
    "data-name": "Rectangle 70",
    width: 5,
    height: 6,
    transform: "translate(55.683 34.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9-2",
    "data-name": "Trac\\xE9 9",
    d: "M99.772,10.591V5H88.591v5.591H83V32.953h5.591v5.591h22.363V32.953h5.591V16.181h-5.591V10.591Z",
    transform: "translate(-55.047 23.185)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71-2",
    "data-name": "Rectangle 71",
    width: 6,
    height: 34,
    transform: "translate(83.683 28.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72-2",
    "data-name": "Rectangle 72",
    width: 6,
    height: 6,
    transform: "translate(66.683 28.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73-2",
    "data-name": "Rectangle 73",
    width: 11,
    height: 6,
    transform: "translate(44.683 28.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74-2",
    "data-name": "Rectangle 74",
    width: 5,
    height: 11,
    transform: "translate(78.683 17.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10-2",
    "data-name": "Trac\\xE9 10",
    d: "M133.316,8.591h-5.591V3H116.544V8.591h5.591v5.591h5.591V47.726h-5.591v5.591h-5.591v5.591H105.363V64.5H83v5.591h33.544V64.5h11.181V58.907h5.591V47.726h5.591V14.181h-5.591Z",
    transform: "translate(-55.047 14.004)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-2",
    "data-name": "Rectangle 75",
    width: 6,
    height: 5,
    transform: "translate(60.683 23.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11-2",
    "data-name": "Trac\\xE9 11",
    d: "M108.953,8.591V3H92.181V8.591H86.591v5.591H81V47.726h5.591v5.591h5.591v5.591h33.544V53.316h5.591V47.726h5.591V19.772h-5.591V14.181h-5.591V8.591Zm16.772,11.181V42.135h-5.591v5.591H108.953v5.591H97.772V47.726H92.181V19.772h5.591V14.181h22.363v5.591Z",
    transform: "translate(-64.228 14.004)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76-2",
    "data-name": "Rectangle 76",
    width: 5,
    height: 11,
    transform: "translate(5.683 17.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77-2",
    "data-name": "Rectangle 77",
    width: 6,
    height: 6,
    transform: "translate(72.683 17.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78-2",
    "data-name": "Rectangle 78",
    width: 16,
    height: 6,
    transform: "translate(44.683 17.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79-2",
    "data-name": "Rectangle 79",
    width: 6,
    height: 6,
    transform: "translate(72.683 11.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80-2",
    "data-name": "Rectangle 80",
    width: 12,
    height: 6,
    transform: "translate(60.683 11.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81-2",
    "data-name": "Rectangle 81",
    width: 6,
    height: 6,
    transform: "translate(10.683 11.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82-2",
    "data-name": "Rectangle 82",
    width: 12,
    height: 5,
    transform: "translate(60.683 6.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83-2",
    "data-name": "Rectangle 83",
    width: 16,
    height: 5,
    transform: "translate(44.683 6.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-2",
    "data-name": "Rectangle 84",
    width: 11,
    height: 5,
    transform: "translate(16.683 6.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85-2",
    "data-name": "Rectangle 85",
    width: 33,
    height: 6,
    transform: "translate(27.683 0.044)",
    fill: "#231e2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_39",
    "data-name": "Groupe 39",
    transform: "translate(979.317 147.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57-3",
    "data-name": "Rectangle 57",
    width: 23,
    height: 5,
    transform: "translate(18.683 57.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58-3",
    "data-name": "Rectangle 58",
    width: 8,
    height: 3,
    transform: "translate(41.683 54.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59-3",
    "data-name": "Rectangle 59",
    width: 7,
    height: 3,
    transform: "translate(11.683 54.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60-3",
    "data-name": "Rectangle 60",
    width: 4,
    height: 4,
    transform: "translate(49.683 50.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61-3",
    "data-name": "Rectangle 61",
    width: 15,
    height: 4,
    transform: "translate(18.683 50.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8-3",
    "data-name": "Trac\\xE9 8",
    d: "M94.281,50.664v-3.82h-3.82v-3.82h-3.82V16.281h3.82v-3.82h3.82V8.641H117.2V4.82H105.742V1H94.281V4.82H86.641v3.82H82.82v7.641H79V39.2h3.82v7.641h3.82v3.82Z",
    transform: "translate(-75.28 2.993)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62-3",
    "data-name": "Rectangle 62",
    width: 4,
    height: 4,
    transform: "translate(7.683 50.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63-3",
    "data-name": "Rectangle 63",
    width: 3,
    height: 4,
    transform: "translate(15.683 46.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64-3",
    "data-name": "Rectangle 64",
    width: 3,
    height: 8,
    transform: "translate(53.683 42.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65-3",
    "data-name": "Rectangle 65",
    width: 8,
    height: 4,
    transform: "translate(22.683 42.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66-3",
    "data-name": "Rectangle 66",
    width: 4,
    height: 4,
    transform: "translate(11.683 42.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67-3",
    "data-name": "Rectangle 67",
    width: 4,
    height: 8,
    transform: "translate(3.683 42.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68-3",
    "data-name": "Rectangle 68",
    width: 4,
    height: 4,
    transform: "translate(18.683 38.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69-3",
    "data-name": "Rectangle 69",
    width: 4,
    height: 23,
    transform: "translate(-0.317 19.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70-3",
    "data-name": "Rectangle 70",
    width: 4,
    height: 4,
    transform: "translate(37.683 23.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9-3",
    "data-name": "Trac\\xE9 9",
    d: "M94.461,8.82V5H86.82V8.82H83V24.1h3.82v3.82H102.1V24.1h3.82V12.641H102.1V8.82Z",
    transform: "translate(-63.999 14.274)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71-3",
    "data-name": "Rectangle 71",
    width: 4,
    height: 23,
    transform: "translate(56.683 19.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72-3",
    "data-name": "Rectangle 72",
    width: 4,
    height: 4,
    transform: "translate(45.683 19.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73-3",
    "data-name": "Rectangle 73",
    width: 7,
    height: 4,
    transform: "translate(30.683 19.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74-3",
    "data-name": "Rectangle 74",
    width: 3,
    height: 7,
    transform: "translate(53.683 12.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10-3",
    "data-name": "Trac\\xE9 10",
    d: "M117.383,6.82h-3.82V3h-7.641V6.82h3.82v3.82h3.82V33.562h-3.82v3.82h-3.82V41.2H98.281v3.82H83v3.82h22.922v-3.82h7.641V41.2h3.82V33.562h3.82V10.641h-3.82Z",
    transform: "translate(-63.999 8.633)",
    fill: "#e2b436"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-3",
    "data-name": "Rectangle 75",
    width: 4,
    height: 3,
    transform: "translate(41.683 16.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11-3",
    "data-name": "Trac\\xE9 11",
    d: "M100.1,6.82V3H88.641V6.82H84.82v3.82H81V33.562h3.82v3.82h3.82V41.2h22.922v-3.82h3.82v-3.82h3.82v-19.1h-3.82v-3.82h-3.82V6.82Zm11.461,7.641V29.742h-3.82v3.82H100.1v3.82H92.461v-3.82h-3.82v-19.1h3.82v-3.82h15.281v3.82Z",
    transform: "translate(-69.64 8.633)",
    fill: "#cf8934"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76-3",
    "data-name": "Rectangle 76",
    width: 4,
    height: 7,
    transform: "translate(3.683 12.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77-3",
    "data-name": "Rectangle 77",
    width: 4,
    height: 4,
    transform: "translate(49.683 12.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78-3",
    "data-name": "Rectangle 78",
    width: 11,
    height: 4,
    transform: "translate(30.683 12.044)",
    fill: "#c2751d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79-3",
    "data-name": "Rectangle 79",
    width: 4,
    height: 4,
    transform: "translate(49.683 8.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80-3",
    "data-name": "Rectangle 80",
    width: 8,
    height: 4,
    transform: "translate(41.683 8.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81-3",
    "data-name": "Rectangle 81",
    width: 4,
    height: 4,
    transform: "translate(7.683 8.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82-3",
    "data-name": "Rectangle 82",
    width: 8,
    height: 4,
    transform: "translate(41.683 4.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83-3",
    "data-name": "Rectangle 83",
    width: 11,
    height: 4,
    transform: "translate(30.683 4.044)",
    fill: "#f5f38e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84-3",
    "data-name": "Rectangle 84",
    width: 7,
    height: 4,
    transform: "translate(11.683 4.044)",
    fill: "#231e2b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85-3",
    "data-name": "Rectangle 85",
    width: 23,
    height: 4,
    transform: "translate(18.683 0.044)",
    fill: "#231e2b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpreuveCoffre);
export default __webpack_public_path__ + "static/media/epreuve_coffre.64abff8b6ee25c38aa8c29d95e48f614.svg";
export { ForwardRef as ReactComponent };